import * as React from "react";
const SvgClose = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" {...props}><path fill="#E5C496" fillRule="nonzero" d="M12 1.2 10.8 0 6 4.8 1.2 0 0 1.2 4.8 6 0 10.8 1.2 12 6 7.2l4.8 4.8 1.2-1.2L7.2 6z" /></svg>;
export default SvgClose;